var _rect, _rect2, _circle, _ellipse, _ellipse2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg3Pl = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 36"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 35,
  height: 35,
  x: 0.5,
  y: 0.5,
  fill: "#EAF0FD",
  fillOpacity: 0.75,
  rx: 3.931
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 35,
  height: 35,
  x: 0.5,
  y: 0.5,
  stroke: "#2F64ED",
  rx: 3.931
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 18,
  r: 11.631,
  stroke: "#2F64ED"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 17.723,
  cy: 18,
  stroke: "#2F64ED",
  rx: 8.031,
  ry: 11.631
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 18,
  cy: 18,
  stroke: "#2F64ED",
  rx: 3.323,
  ry: 11.631
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F64ED",
  d: "M6.646 18h23.262M8.031 11.908H27.97M8.031 24.092H27.97"
})));
export { Svg3Pl as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIzNSIgaGVpZ2h0PSIzNSIgcng9IjMuOTMwNzciIGZpbGw9IiNFQUYwRkQiIGZpbGwtb3BhY2l0eT0iMC43NSIvPgo8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjM1IiBoZWlnaHQ9IjM1IiByeD0iMy45MzA3NyIgc3Ryb2tlPSIjMkY2NEVEIi8+CjxjaXJjbGUgY3g9IjE3Ljk5OTkiIGN5PSIxNy45OTk5IiByPSIxMS42MzA4IiBzdHJva2U9IiMyRjY0RUQiLz4KPGVsbGlwc2UgY3g9IjE3LjcyMzIiIGN5PSIxNy45OTk5IiByeD0iOC4wMzA3NyIgcnk9IjExLjYzMDgiIHN0cm9rZT0iIzJGNjRFRCIvPgo8ZWxsaXBzZSBjeD0iMTcuOTk5OCIgY3k9IjE3Ljk5OTkiIHJ4PSIzLjMyMzA4IiByeT0iMTEuNjMwOCIgc3Ryb2tlPSIjMkY2NEVEIi8+CjxwYXRoIGQ9Ik02LjY0NjQ4IDE4SDI5LjkwOCIgc3Ryb2tlPSIjMkY2NEVEIi8+CjxwYXRoIGQ9Ik04LjAzMTI1IDExLjkwNzdIMjcuOTY5NyIgc3Ryb2tlPSIjMkY2NEVEIi8+CjxwYXRoIGQ9Ik04LjAzMTI1IDI0LjA5MjNIMjcuOTY5NyIgc3Ryb2tlPSIjMkY2NEVEIi8+Cjwvc3ZnPgo=";